import {Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'app-panel',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss'],
    standalone: false
})
export class PanelComponent {
  @Input() hasDropdown: boolean = false;
  @Input() isUsed: string | undefined;
  @Input() disabled: boolean = true;
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();
  @Output() openChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('content', {static: false}) contentPanel?: ElementRef;

  isDropdownOpen = false;

  @HostListener('document:mousedown', ['$event'])
  onDocumentClick(event: Event): void {
    if (this.isDropdownOpen && this.contentPanel && !this.contentPanel!.nativeElement.contains(event.target)) {
      this.closeDropdown();
    }
  }

  toggleDropdown(event: Event) {
    if (!this.disabled) {
      event.stopPropagation()
      this.isDropdownOpen = !this.isDropdownOpen;
      this.openChange.emit(this.isDropdownOpen);
    }
  }

  closeDropdown() {
    this.isDropdownOpen = false;
    this.openChange.emit(this.isDropdownOpen);
    this.onClose.emit()
  }

}
